import React from "react";
import { CheckCircleIcon, EllipsisVerticalIcon } from "@heroicons/react/24/outline";
import { Menu as HeadlessMenu } from "@headlessui/react";
import { CheckIcon } from "@heroicons/react/24/solid";

export default function ToolInfoTable({ data }) {
  return (
    <div className="xl:col-span-2 bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden mx-auto">
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
        <div className="flex items-center justify-between w-full">
          <p className="text-gray-800 font-semibold mb-1 text-center">مشخصات ابزار</p>
          <p className="flex items-center gap-1 text-green-600 text-sm">
            <CheckCircleIcon className="w-4 h-4 text-green-400" />
            <strong>وضعیت: فعال </strong> 
          </p>
        </div>
        {/* <HeadlessMenu as="div" className="relative inline-block text-left">
          <HeadlessMenu.Button className="inline-flex justify-center">
            <button className="p-2 rounded hover:bg-gray-100">
              <EllipsisVerticalIcon className="w-6 h-6" />
            </button>
          </HeadlessMenu.Button>
          <HeadlessMenu.Items className="absolute right-0 mt-2 w-56 bg-white border border-gray-200 rounded-md shadow-lg">
            <HeadlessMenu.Item>
              {({ active }) => <button className={`${active ? "bg-gray-100" : ""} w-full text-left px-4 py-2 text-sm text-gray-700`}>Action</button>}
            </HeadlessMenu.Item>
            <HeadlessMenu.Item>
              {({ active }) => <button className={`${active ? "bg-gray-100" : ""} w-full text-left px-4 py-2 text-sm text-gray-700`}>Another Action</button>}
            </HeadlessMenu.Item>
            <HeadlessMenu.Item>
              {({ active }) => <button className={`${active ? "bg-gray-100" : ""} w-full text-left px-4 py-2 text-sm text-gray-700`}>Something else here</button>}
            </HeadlessMenu.Item>
          </HeadlessMenu.Items>
        </HeadlessMenu> */}
      </div>
      <div className="overflow-x-auto p-0 pt-0 pb-2">
        <table className="w-full min-w-[640px] table-auto">
          <thead>
            <tr>
              {["ردیف", "تاریخ و ساعت", " نام و نام خانوادگی","نام کالا" ,"تعداد ","کد پیگیری"].map((el) => (
                <th key={el} className="border-b border-gray-100 py-3 px-6 text-center ">
                  <p className="text-xs font-medium uppercase text-gray-400">{el}</p>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map(({ img, id, type, budget, fullname,productName ,count,TrackingCode,date}, key) => (
              <tr key={id}>
                <td className={`py-3 px-5 ${key !== data.length - 1 ? "border-b border-gray-100" : ""}`}>
                  <div className="flex items-center gap-4">
                    {/* <img src={img} alt={name} className="w-8 h-8 rounded-full object-cover" /> */}
                    <p className="text-gray-800 font-bold text-sm">{id}</p>
                  </div>
                </td>
                <td className={`py-3 px-5 ${key !== data.length - 1 ? "border-b border-gray-100" : ""}`}>
                  {date}
                </td>
                <td className={`py-3 px-5 ${key !== data.length - 1 ? "border-b border-gray-100" : ""}`}>
                  {fullname}
                </td>
                <td className={`py-3 px-5 ${key !== data.length - 1 ? "border-b border-gray-100" : ""}`}>
                  <p className="text-gray-600 text-xs font-medium">{productName}</p>
                </td>
                <td className={`py-3 px-5 ${key !== data.length - 1 ? "border-b border-gray-100" : ""}`}>
                  <p className="text-gray-600 text-xs font-medium">{count}</p>
                </td>
                <td className={`py-3 px-5 ${key !== data.length - 1 ? "border-b border-gray-100" : ""}`}>
                  <div className="w-10/12 flex items-center justify-center">
                  {/* <CheckIcon className="w-6 h-6 text-green-500" /> */}
                  {TrackingCode}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
